// What the workspace shows when it opens, and the rule that stops it from
// overruling the person.
//
// The bug this exists for: the initial effect awaits five requests before it
// finally selects a default channel. Anyone who clicked in the sidebar during
// that window had their choice overwritten when the effect's tail landed —
// the highlight flipped, the content snapped back to #general, and the second
// click worked because by then the effect had finished.
//
// Pure, so the deep-link table below is testable without rendering a page.

export const INITIAL = { kind: "channel", id: null };

/** The placeholder the workspace starts on, before anything has been chosen. */
export function isUnchosen(selection) {
  return selection?.kind === "channel" && !selection.id;
}

// ?ticket=/?channel=/?dm=/?board=/?canvas= arrive from a push notification or a
// popped-out window. First match wins; the order is the order of specificity.
const LINKS = [
  ["ticket", (id) => ({ selection: { kind: "feedback" }, ticketId: id })],
  ["channel", (id) => ({ selection: { kind: "channel", id } })],
  ["dm", (id) => ({ selection: { kind: "dm", id } })],
  ["board", (id) => ({ selection: { kind: "board", id }, windowed: true })],
  ["canvas", (id) => ({ selection: { kind: "canvas", id }, windowed: true })],
];

/**
 * What to open: `{ selection, ticketId?, standalone, keepUrl }`, or null when
 * there is nothing to open (no deep link and no channels).
 *
 * `keepUrl` marks the one case where the query string must survive — a
 * standalone board or whiteboard window keeps its URL so a refresh reopens the
 * same thing.
 */
export function initialSelection({ search, channels, asWindow = false }) {
  const params = new URLSearchParams(search || "");
  for (const [key, build] of LINKS) {
    const value = params.get(key);
    if (!value) continue;
    const { selection, ticketId, windowed } = build(value);
    return {
      selection,
      ticketId: ticketId || null,
      standalone: Boolean(windowed && asWindow),
      keepUrl: Boolean(windowed && asWindow),
    };
  }
  const first = (channels || [])[0];
  if (!first) return null;
  return { selection: { kind: "channel", id: first.id }, ticketId: null,
           standalone: false, keepUrl: false };
}
